export const getAccount = () => {
    const storigedAccount = localStorage.getItem('account');
    return storigedAccount ? JSON.parse(storigedAccount) : {};
};
